import React, { useState } from 'react'
import { CModal, CModalBody, CButton } from '@coreui/react'
import BackArrow from '../../../assets/back-arrow.svg'
import Desktop from '../../../assets/desktop.svg'
import DesktopActive from '../../../assets/desktop-active.svg'
import Mobile from '../../../assets/mobile.svg'
import MobileActive from '../../../assets/mobile-active.svg'
import CustomImage from 'src/components/customImage/customImage'

const TemplatePreviewModal = ({ previewData, onBack, onStart }) => {
  const [viewToggle, setViewToggle] = useState('WEB')
  return (
    <CModal size="xl" className="website-preview-modal" visible={true}>
      <CModalBody style={{ padding: '0rem 0rem' }} className="">
        <div className="d-flex justify-content-between align-items-center h-100 px-5 border">
          <div
            style={{ fontSize: '1.0rem', height: '4rem', width: '20%' }}
            className="d-flex align-items-center"
          >
            <div className="cursor-pointer d-flex align-items-center" onClick={onBack}>
              <img src={BackArrow} style={{ marginRight: '0.5rem' }} alt="back" />
              BACK
            </div>
          </div>
          <div className="">
            {viewToggle === 'WEB' ? (
              <div className="d-flex justify-content-center align-items-center">
                <img src={DesktopActive} alt="DesktopActive" className="mx-4 cursor-pointer" />
                <img
                  src={Mobile}
                  alt="Mobile"
                  onClick={() => setViewToggle('MOBILE')}
                  className="mx-4 cursor-pointer"
                />
              </div>
            ) : (
              <div className="d-flex justify-content-center align-items-center">
                <img
                  src={Desktop}
                  alt="Desktop"
                  onClick={() => setViewToggle('WEB')}
                  className="mx-4 cursor-pointer"
                />
                <img src={MobileActive} alt="MobileActive" className="mx-4 cursor-pointer" />
              </div>
            )}
          </div>
          <div style={{ width: '20%' }} className=" d-flex justify-content-end">
            <CButton
              className=" bg-black rounded-1 btn-focus-none"
              onClick={() => onStart(previewData)}
            >
              START WITH THIS DESIGN
            </CButton>
          </div>
        </div>
        <div className="static-scrollbar-class" style={{ height: '87vh' }}>
          {viewToggle === 'WEB' ? (
            <div className="d-flex justify-content-center w-100">
              <CustomImage
                imageUrl={previewData?.preview_s3_key?.website}
                imgClass="w-100"
                loaderClass="w-100"
                loaderStyle={{ background: '#5A5A5A50', height: '80vh' }}
                imgAlt={'web'}
              />
            </div>
          ) : (
            <div className="d-flex justify-content-center w-100 ">
              <CustomImage
                imageUrl={previewData?.preview_s3_key?.mobile}
                imgStyle={{ width: '390px' }}
                imgClass=" h-100"
                loaderStyle={{ background: '#5A5A5A50', width: '390px', height: '80vh' }}
                imgAlt={'mob'}
              />
            </div>
          )}
        </div>
      </CModalBody>
    </CModal>
  )
}

export default TemplatePreviewModal
